import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  get_job_list,
  setSearchQuery,
  setSearchColumn,
  get_job_detail,
  proof_log_table,
  setJobData,
  setAssignModalOpen,
  setAssignedToFilter,
  assign_job,
} from "../../../store/job/jobSlice";

import { setStageTab, setProcessTab, get_company_process, setProcessHasJobForm } from "../../../store/user/userSlice";


const mapStateToProps = (state) => {
    const { selected_stage_tab, selected_process_tab, selected_company, company_process } = state.user;
    const {
      job_list,
      total_job_count,
      common_loading,
      search_query,
      search_column,
      search_columns,
      table_columns,
      searchFilters,
      clearJobData,
      job_detail,
      proof_log_data,
      active_assigned_to_filter,
      is_assign_modal_open,
      assign_modal_job_id,
    } = state.job;
    return {
        selected_process_tab,
        selected_stage_tab,
        selected_company,
        company_process,
        job_list,
        job_total: total_job_count,
        common_loading,
        searchFilters,
        search_query,
        search_column,
        search_columns,
        table_columns,
        clearJobData,
        job_detail,
        proof_log_data,
        active_assigned_to_filter,
        is_assign_modal_open,
        assign_modal_job_id,
        logged_in_user: state.auth?.user || null,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            get_job_list,
            setSearchQuery,
            setSearchColumn,
            get_job_detail,
            proof_log_table,
            setJobData,
            setStageTab,
            setProcessTab,
            get_company_process,
            setProcessHasJobForm,
            setAssignModalOpen,
            setAssignedToFilter,
            assign_job,
        },
        dispatch
    );


const Store = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;